<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <h3 class="text-center">Review Book to E&amp;P Reconciliation (Business Reviewer Step) - Dr/(Cr)</h3>
  <table class="table table-bordered custom-table">
    <thead style="text-align: center">
      <tr>
        <th class="text-center">Account Details</th>
        <th class="text-center">Counterparty</th>
        <th class="text-center">Prior Year US GAAP (a)</th>
        <th class="text-center">Current Year US GAAP (b)</th>
        <th class="text-center">E&amp;P Adjustments (c)</th>
        <th class="text-center">US E&amp;P (d = b + c)</th>
      </tr>
      <tr>
        <th>Assets</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (item of review_book_data; track $index) {
<tr>
        <td>{{item.acc_det}}</td>
        <td>{{item.count_party}}</td>
        <td class="text-right">{{item.prior_year}}</td>
        <td class="text-right">{{item.curr_year}}</td>
        <td class="text-right">{{item.ep_adj}}</td>
        <td class="text-right">{{item.us_ep}}</td>
      </tr>
}
    </tbody>
  </table>
</div>
